// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/risk.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/index.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/indicator.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/network.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/budgeting.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/sunny.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/moderate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/rain.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/evaluation.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images/change.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spotlight {
  height: calc(100vh - 72px);
  overflow: auto;
  width: 100%; }
  .spotlight .header-card {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column; }

.ant-card-hoverable {
  box-shadow: 0 0 12px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  position: relative; }
  .ant-card-hoverable .ant-card-body {
    padding: 8px; }

.ant-card-hoverable {
  cursor: default; }

.objective-card {
  position: relative;
  cursor: pointer; }
  .objective-card:hover {
    background-color: var(--primary-20); }
    .objective-card:hover .anticon svg {
      fill: white; }
    .objective-card:hover .card-img {
      opacity: 1;
      filter: brightness(0) invert(1); }

.object-hover {
  cursor: default;
  width: calc(100% - 10%);
  position: absolute;
  top: calc(100% - 4px);
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #d0daff;
  padding: 16px;
  border-radius: 12px;
  z-index: 10; }
  .object-hover li {
    padding: 6px 0;
    font-size: 12px;
    font-weight: bold;
    color: var(--black-10); }
  .object-hover .objective-link {
    margin-top: 12px;
    font-size: 14px;
    font-weight: bold;
    padding: 4px;
    text-align: center;
    color: var(--black-10);
    background-color: white;
    border-radius: 4px; }
    .object-hover .objective-link:hover {
      color: var(--black-10); }
  .object-hover::after {
    content: " ";
    position: absolute;
    top: -10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid var(--primary-20); }

.card-img {
  position: absolute;
  right: 10%;
  bottom: 24px;
  width: 75px;
  height: 75px;
  opacity: 0.3;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain; }
  .card-img.rocket-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }
  .card-img.index-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }
  .card-img.success-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }
  .card-img.energy-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }
  .card-img.bet-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
  .card-img.sunny-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }
  .card-img.moderate-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }
  .card-img.gloomy-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }
  .card-img.risk-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); }
  .card-img.engagment-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___}); }

@media all and (max-width: 1024px) {
  .spotlight {
    padding: 40px 24px !important; }
    .spotlight .ant-col {
      padding: 12px !important; } }

@media all and (max-width: 768px) {
  .spotlight {
    padding: 24px !important; }
    .spotlight .ant-row {
      margin-bottom: 0 !important; }
      .spotlight .ant-row .ant-card {
        padding: 16px !important; }
    .spotlight .spotlight-select {
      margin-top: 0 !important; } }
`, "",{"version":3,"sources":["webpack://./src/pages/spotLight/spotlight.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,cAAc;EACd,WAAW,EAAA;EAHf;IAKQ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB,EAAA;;AAI9B;EACI,2CAAwC;EACxC,oBAAoB;EACpB,kBAAkB,EAAA;EAHtB;IAKQ,YAAY,EAAA;;AAIpB;EACI,eAAe,EAAA;;AAGnB;EACI,kBAAkB;EAClB,eAAe,EAAA;EAFnB;IAIQ,mCAAmC,EAAA;IAJ3C;MAOgB,WAAW,EAAA;IAP3B;MAWY,UAAU;MACV,+BAA+B,EAAA;;AAI3C;EACI,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,yBAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,WAAW,EAAA;EAXf;IAaQ,cAAc;IACd,eAAe;IACf,iBAAiB;IACb,sBAAsB,EAAA;EAhBlC;IAmBQ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IAClB,uBAAuB;IAC3B,kBAAkB,EAAA;IA1B1B;MA4BY,sBAAsB,EAAA;EA5BlC;IAgCQ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,cAAc;IACd,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,2CAA2C,EAAA;;AAInD;EACI,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB,EAAA;EAT5B;IAWQ,yDAAqD,EAAA;EAX7D;IAcQ,yDAAsD,EAAA;EAd9D;IAiBQ,yDAA0D,EAAA;EAjBlE;IAoBQ,yDAAwD,EAAA;EApBhE;IAuBQ,yDAA0D,EAAA;EAvBlE;IA0BQ,yDAAsD,EAAA;EA1B9D;IA6BQ,yDAAyD,EAAA;EA7BjE;IAgCQ,yDAAqD,EAAA;EAhC7D;IAmCQ,yDAA2D,EAAA;EAnCnE;IAsCQ,yDAAuD,EAAA;;AAI/D;EACI;IACI,6BAA6B,EAAA;IADjC;MAGQ,wBAAwB,EAAA,EAC3B;;AAIT;EACI;IACI,wBAAwB,EAAA;IAD5B;MAGQ,2BAA2B,EAAA;MAHnC;QAKY,wBAAwB,EAAA;IALpC;MASQ,wBAAwB,EAAA,EAC3B","sourcesContent":[".spotlight {\n    height: calc(100vh - 72px);\n    overflow: auto;\n    width: 100%;\n    .header-card {\n        height: 80px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n    }\n}\n\n.ant-card-hoverable {\n    box-shadow: 0 0 12px 5px rgba(0,0,0,0.1);\n    transition: all 0.3s;\n    position: relative;\n    .ant-card-body {\n        padding: 8px;\n    }\n}\n\n.ant-card-hoverable {\n    cursor: default;\n}\n\n.objective-card {\n    position: relative;\n    cursor: pointer;\n    &:hover {\n        background-color: var(--primary-20);\n        .anticon {\n            svg {\n                fill: white;\n            }\n        }\n        .card-img {\n            opacity: 1;\n            filter: brightness(0) invert(1);\n        }\n    }\n}\n.object-hover {\n    cursor: default;\n    width: calc(100% - 10%);\n    position: absolute;\n    top: calc(100% - 4px);\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    background-color: rgb(208, 218, 255);\n    padding: 16px;\n    border-radius: 12px;\n    z-index: 10;\n    li {\n        padding: 6px 0;\n        font-size: 12px;\n        font-weight: bold;\n            color: var(--black-10);\n    }\n    .objective-link {\n        margin-top: 12px;\n        font-size: 14px;\n        font-weight: bold;\n        padding: 4px;\n        text-align: center;\n        color: var(--black-10);\n            background-color: white;\n        border-radius: 4px;\n        &:hover {\n            color: var(--black-10);\n        }\n    }\n    &::after {\n        content: \" \";\n        position: absolute;\n        top: -10px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n        width: 0; \n        height: 0; \n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-bottom: 10px solid var(--primary-20);\n    }\n}\n\n.card-img {\n    position: absolute;\n    right: 10%;\n    bottom: 24px;\n    width: 75px;\n    height: 75px;\n    opacity: 0.3;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    &.rocket-img {\n        background-image: url('../../assets/images/risk.png');\n    }\n    &.index-img {\n        background-image: url('../../assets/images/index.png');\n    }\n    &.success-img {\n        background-image: url('../../assets/images/indicator.png');\n    }\n    &.energy-img {\n        background-image: url('../../assets/images/network.png');\n    }\n    &.bet-img {\n        background-image: url('../../assets/images/budgeting.png');\n    }\n    &.sunny-img {\n        background-image: url('../../assets/images/sunny.png');\n    }\n    &.moderate-img {\n        background-image: url('../../assets/images/moderate.png');\n    }\n    &.gloomy-img {\n        background-image: url('../../assets/images/rain.png');\n    }\n    &.risk-img {\n        background-image: url('../../assets/images/evaluation.png');\n    }\n    &.engagment-img {\n        background-image: url('../../assets/images/change.png');\n    }\n}\n\n@media all and (max-width: 1024px) {\n    .spotlight {\n        padding: 40px 24px !important;\n        .ant-col {\n            padding: 12px !important;\n        }\n    }\n}\n\n@media all and (max-width: 768px) {\n    .spotlight {\n        padding: 24px !important;\n        .ant-row {\n            margin-bottom: 0 !important;\n            .ant-card {\n                padding: 16px !important;\n            }\n        }\n        .spotlight-select {\n            margin-top: 0 !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
